import { DEAL_STATUS } from "../../../services/clientifyService.js";

/** Board column a deal belongs on: closed deals by status, open ones by stage. */
export const columnKeyForDeal = (deal) => {
  const status = String(deal?.status);
  if (status === DEAL_STATUS.won) return "won";
  if (status === DEAL_STATUS.lost) return "lost";
  return `stage:${deal?.pipeline_stage_id}`;
};
